import { render, staticRenderFns } from "./YzTextarea.vue?vue&type=template&id=1eda65b1&scoped=true&lang=pug&"
import script from "./YzTextarea.vue?vue&type=script&lang=js&"
export * from "./YzTextarea.vue?vue&type=script&lang=js&"
import style0 from "./YzTextarea.vue?vue&type=style&index=0&id=1eda65b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda65b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
